import { Box, Heading, PseudoBox, Text } from '@chakra-ui/core';
import React, { useEffect, useState } from 'react';
import { Prescription } from '../types';
import { formatTimeList } from '../util';
import { FaTrash } from 'react-icons/fa';
import { user } from '../firebase/firebase';

interface Props {
  prescription: Prescription;
}

const PrescriptionCard: React.FC<Props> = (props: Props) => {
  const [hovering, setHovering] = useState(false);
  const p = props.prescription;

  return (
    <PseudoBox
      as={Box}
      borderRadius={10}
      p={6}
      w="sm"
      bg="white"
      border="1px black"
      transition="linear 0.1s"
      position="relative"
      onMouseEnter={(): void => setHovering(true)}
      onMouseLeave={(): void => setHovering(false)}
    >
      <Heading size="lg">{p.name}</Heading>
      <Text>
        {p.amt} {p.u}
        {p.amt !== 1 && 's'}
        {p.times.length > 0 ? ` at ${formatTimeList(p.times)}` : ''}
      </Text>
      {hovering && (
        <PseudoBox
          h={8}
          w={8}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
          top="8px"
          right="8px"
          cursor="pointer"
          borderRadius="4px"
          transition="0.2s linear"
          // bg="white"
          _hover={{ bg: 'gray.200' }}
          onClick={async (): Promise<void> => {
            await user.collection('prescriptions').doc(p._id).delete();
          }}
        >
          <Box as={FaTrash} />
        </PseudoBox>
      )}
    </PseudoBox>
  );
};

export default PrescriptionCard;
